export class CasillaInicio
{
    casillaRegion:string;
    idHeading:string;
    collapseId:string;
    calle:string;
    calle2:string;
    zipCode:string;
    ciudad:string;
    state:string;
    telefono:string;
    colapse:string;
    inicio:string;

    constructor(casillaRegion:string,
        idHeading:string,
        collapseId:string,
        calle:string,
        calle2:string,
        zipCode:string,
        state:string,
        telefono:string,
        ciudad:string,
        colapse:string,
        inicio:string)
        {
            this.casillaRegion=casillaRegion;
            this.idHeading=idHeading;
            this.collapseId=collapseId;
            this.calle=calle;
            this.calle2=calle2;
            this.zipCode=zipCode;
            this.state=state;
            this.telefono=telefono;
            this.ciudad=ciudad;
            this.colapse=colapse;
            this.inicio=inicio;
        }
}

export const Miami:CasillaInicio=
{
    casillaRegion:"Miami",
    idHeading:"headingOne",
    collapseId:"collapseOne",
    calle:"2250 NW 114th ",
    calle2:"Unit 1W",
    zipCode:"33192-4177",
    state:"Florida (o FL)",
    telefono:"(786) 999 8545",
    ciudad:"Miami",
    colapse:"accordion-button",
    inicio:"true"
}

export const Espana:CasillaInicio=
{
    casillaRegion:"España",
    idHeading:"headingTwo",
    collapseId:"collapseTwo",
    calle:"Avenida de la Industria 38 - Nave D-8",
    calle2:"",
    zipCode:"28823",
    state:"Coslada",
    telefono:"+34 914285478",
    ciudad:"Madrid",
    colapse:"accordion-button collapsed",
    inicio:"false"
}